import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { useSidebarContext } from '@user/Sidebar';
import { useFollowingUser } from '../useFollowingUser';

export const FollowingIndicator: React.FC = () => {
  const { t } = useTranslation();
  const { followingViewer, stopFollowing } = useFollowingUser();
  const { isSidebarVisible, sidebarWidth } = useSidebarContext();
  const hintId = useId();

  const leftOffset = isSidebarVisible ? sidebarWidth : 0;

  if (!followingViewer) {
    return null;
  }

  return (
    <>
      {/* フォロー中ボーダー */}
      <div
        className="pointer-events-none fixed inset-y-0 right-0 z-40 border-10 border-orange-500"
        style={{ left: leftOffset, transition: 'left 0.3s' }}
        aria-hidden="true"
      />
      <div
        className="fixed bottom-4 z-50 -translate-x-1/2"
        style={{ left: `calc(${leftOffset}px + (100vw - ${leftOffset}px) / 2)`, transition: 'left 0.3s' }}
      >
        <div
          className="flex items-center gap-2 rounded-full border border-orange-500 bg-orange-50 px-4 py-2 text-sm text-gray-800 shadow-lg"
          role="status"
          aria-live="polite"
        >
          <span>{t('canvas.viewer.following.status', { userName: followingViewer.userName })}</span>
          <button
            onClick={stopFollowing}
            className="ml-2 flex size-6 items-center justify-center rounded-full bg-black/10 transition-colors hover:bg-gray-200"
            title={t('canvas.viewer.following.stop')}
            aria-label={t('canvas.viewer.following.stop')}
            aria-describedby={hintId}
          >
            <FontAwesomeIcon icon={faXmark} className="text-gray-600" />
          </button>
          <span id={hintId} className="sr-only">
            {t('canvas.viewer.following.escHint')}
          </span>
        </div>
      </div>
    </>
  );
};
